<mt-filter
    [filterConfig]="filterConfig"
    [progressBar]="filterConfig.isLoading"
    (filterChange)="filterData($event)"
></mt-filter>

<div class="report-container mt-4" *ngIf="tableConfig">
    <div class="header-container flex-row">
        <div class="title">
            {{ "spot conditions" | lang | uppercase }}
        </div>

        <div class="excel-export" *ngIf="tableConfig.dataset?.length > 0">
            <app-button-icon
                [image]="'download'"
                [iconType]="'icon'"
                [disabled]="disabledExcelBtn"
                [spinner]="btnSpinner"
                (clickHandler)="downloadExcel()"
            ></app-button-icon>
        </div>
    </div>
    <div [ngClass]="{ 'body-container': tableConfig }">
        <app-main-table [tableConfig]="tableConfig"></app-main-table>
    </div>
</div>
